<mat-accordion>
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title> Stand-alone CMs </mat-panel-title>
      <!-- <mat-panel-description> Something can be useful here</mat-panel-description> -->
    </mat-expansion-panel-header>
    <diV class="standalone-cm-list">
      @for (cm of standaloneCMs; track $index) {
        <div class="standalone-cm">
          {{ cm.name }}
          <div class="buttons">
            <a href="{{ cm.wiki_url }}" target="_blank">
              <button matIconButton aria-label="CM wiki" matTooltip="CM wiki">
                <mat-icon>menu_book</mat-icon>
              </button>
            </a>
            <a href="{{ cm.repository_url }}" target="_blank">
              <button matIconButton aria-label="Repository URL" matTooltip="Repository URL">
                <mat-icon>folder_data</mat-icon>
              </button>
            </a>
          </div>
        </div>
      }
    </diV>
  </mat-expansion-panel>
</mat-accordion>
